// Hope Giver mark: deep teal circle, metallic gold heart held by two outlined hands.
export function LogoMark({ size = 44, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      className={className}
      role="img"
      aria-label="Hope Giver logo"
    >
      <defs>
        <linearGradient id="hgGold" x1="30" y1="20" x2="75" y2="70" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#F3E096" />
          <stop offset="0.5" stopColor="#D4AF37" />
          <stop offset="1" stopColor="#B59328" />
        </linearGradient>
      </defs>
      <circle cx="50" cy="50" r="50" fill="#0D4B56" />
      {/* hands */}
      <g stroke="url(#hgGold)" strokeWidth="3.4" strokeLinecap="round" strokeLinejoin="round" fill="none">
        <path d="M50 70 C 42 62, 30 56, 26 47 L 26 38 L 36 44" />
        <path d="M50 70 C 58 62, 70 56, 74 47 L 74 38 L 64 44" />
      </g>
      {/* heart */}
      <path
        d="M50 30 C 45 22, 32 23, 30 33 C 28.5 41, 38 49, 50 58 C 62 49, 71.5 41, 70 33 C 68 23, 55 22, 50 30 Z"
        fill="url(#hgGold)"
      />
    </svg>
  );
}

export default function Logo({ light = false, size = "md" }) {
  const markSize = size === "lg" ? 52 : 40;
  return (
    <span className="inline-flex items-center gap-2.5" data-testid="nav-brand-logo">
      <LogoMark size={markSize} />
      <span className="leading-none">
        <span
          className={`block font-script text-2xl font-bold tracking-wide ${
            light ? "text-[#F3E096]" : "text-[#0D4B56]"
          }`}
        >
          hope giver
        </span>
        {size === "lg" && (
          <span className="mt-1 block text-[11px] font-semibold uppercase tracking-[0.3em] text-[#D4AF37]">
            Spreading Hope. Creating Change.
          </span>
        )}
      </span>
    </span>
  );
}
